<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-career`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41 3a2 2 0 012 2v38a2 2 0 01-2 2H7a2 2 0 01-2-2V14a2 2 0 012-2h6V5a2 2 0 012-2h26zm-2 4H17v29a1 1 0 01-1 1h-2a1 1 0 01-1-1V16H9v25h30V7zm-5 20a1 1 0 011 1v2a1 1 0 01-1 1H22a1 1 0 01-1-1v-2a1 1 0 011-1h12zm0-10a1 1 0 011 1v2a1 1 0 01-1 1H22a1 1 0 01-1-1v-2a1 1 0 011-1h12z"/></svg>
</template>
<script>

export default {
  name: 'IconCareer',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
